import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from "@material-ui/core/TableFooter";
import {TablePaginationActions} from "../table-pagination-actions/TablePaginationActions";
import TableLoader from 'components/ui/tables/rows/table-loader/TableLoader';
import PropTypes from "prop-types";
import {Tooltip} from "@material-ui/core";
import {Help} from "@material-ui/icons";
import {colors} from "../../../../shared/colors"

const useStyles = makeStyles({
    root: {
        width: '100%'
    },
    tableHeaders: {
        cursor: "default",
        height: "12px"
    },
    background: {
        backgroundColor: "#f7f7f7"
    }
});

function TableESim(props) {
    const classes = useStyles();
    const handleChangePage = (event, newPage) => {
        props.fetchData(newPage, props.rowsPerPage);
    };

    const handleChangeRowsPerPage = (event) => {
        props.fetchData(0, +event.target.value);
    };

    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.background}>
                <Table stickyHeader aria-label="a dense table" size='small'>
                    <TableHead>
                        <TableRow className={classes.tableHeaders}>
                            {props.headCells.map((column) => (
                                <TableCell
                                    key={"head-cell-" + column.id}
                                    align={column.align}
                                    style={{
                                        minWidth: column.minWidth,
                                        width: column.width,
                                        border: '0.5px solid #e0e0e0'
                                    }}
                                >
                                    {column.label}
                                    {column.tooltip ?
                                        <Tooltip title={column.tooltip}>
                                            <Help fontSize={"small"} style={{color: colors.primary.dark}}/>
                                        </Tooltip> : null
                                    }
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!props.loading ? props.tableRows :
                            <TableLoader loading={props.loading} colSpan={props.headCells.length}/>}
                    </TableBody>
                    {props.showPagination ?
                        <TableFooter>
                            <tr>
                                {props.count !== 0 ? <TablePagination
                                    rowsPerPageOptions={[5, 15, 25]}
                                    count={props.count}
                                    rowsPerPage={props.rowsPerPage}
                                    page={props.page}
                                    SelectProps={{
                                        inputProps: {'aria-label': 'rows per page'},
                                        native: true,
                                    }}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}
                                /> : null}
                            </tr>
                        </TableFooter> : null}
                </Table>
            </TableContainer>

        </Paper>
    );
}

TableESim.propTypes = {
    showPagination: PropTypes.bool,
    page: PropTypes.number,
    rowsPerPage: PropTypes.number,
    count: PropTypes.number,
    loading: PropTypes.bool,
    headCells: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired
}

TableESim.defaultProps = {
    showPagination: false
}

export default TableESim;
